export default {
  last24hours: "Last 24 hours",
  today: "Today",
  yesterday: "Yesterday",
  lastThreeDays: "Last 3 Days",
  lastSevenDays: "Last 7 Days",
  complaintStats: "Complaint Stats",
  tagStats: "Tag Stats",
  conversationStats: "24-hour session statistics",
  kfStat: "Customer service monitoring",
  ratingStatistics: "Rating Stats",
  closedConversations: "Closed",
  openConversations: "Open Issues",
  closedIssues: "Closed Issues",
  ratingCount: "Number of Ratings",
  averageScore: "Average Score",
  serviceStatus: "Service Status",
  unclosedConversations: "Unclosed Conversations",
  unreadConversations: "Unread Conversations",
  conversationStatistics24h: "24h Conversation Statistics",
  employeeID: "Employee ID",
  date: "DATE",
  datePlaceholder: "Please select a date",
  day: "Date of statistics",
  assignCnt: "The total number of assigned tasks",
  finishedCnt: "The number of completed tasks",
  loginCnt: "Number of re-logins",
  rechargeCnt: "Number of recharged",
  calledCnt: "Number of calls",
  connectedCnt: "Number of connections",
  claimedCnt: "Number of gift code recipients",
};
